<div class="w-100">

    <div class="d-flex justify-content-center">
        <img src="/assets/images/404.svg" class="imagen">
    </div>
    <div class="d-flex justify-content-center">
        <h5 class="text">Página no encontrada</h5>
    </div>
</div>